import Easee from './easee';
import alfen from './alfen';

// Must add Easee when ready
export default { easee: Easee, /* wallbox, */ alfen };
